export default __webpack_public_path__ + "static/ing-afe6702857b85e3559abb08176c00913.svg";